import { ChangeDetectionStrategy, Component, Input, SimpleChanges, inject } from '@angular/core';
import { PriceService } from '@df/ui/price/price.service';
import { Product } from '../product.decorator';

/**
 * Displays product price
 */
@Component({
    selector: 'product-price',
    templateUrl: './product-price.html',
    styleUrls: ['./product-price.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPriceComponent {
    protected priceService = inject(PriceService);

    /**
     * Default image
     */
    @Input()
    product?: Product;

    @Input()
    isTradeScope?: boolean = false;

    @Input()
    small = false;

    @Input()
    proPriceMode: boolean = false;

    @Input()
    qty = 1;

    protected get price(): number {
        return this.product?.calcPrice(false, { qty: this.qty || 1 }) || 0;
    }
}
